import { useDispatch, useSelector } from 'react-redux'
import ArrowUpTrayIcon from '../../../../components/elements/icons/ArrowUpTrayIcon'
import { useEffect, useState } from 'react'
import { fetchSundryAccounts } from '../../../../store/actions/sundriesActions'
import Loader from '../../../../components/elements/Loader'
import DataTable from '../../../../components/elements/DataTable'
import { debounce, tableHeadersFields } from '../../../../utils'
import ApplicantTableSnippet from '../../../../components/partials/applications/ApplicantTableSnippet'
import StudentStatus from '../../../../components/elements/StudentStatus'
import SearchField from '../../../../components/elements/SearchField'
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon'
import { Link } from 'react-router-dom'
import ChevronIcon from '../../../../components/elements/icons/ChevronIcon'
import SundryAccountFilters from '../../../../components/elements/filters/SundryAccountFilters'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import NewSundryItem from '../../../../components/partials/sundry/NewSundryItem'
import SundryItems from '../../../../components/partials/sundry/SundryItems'

const SundryAccounts = () => {
  const dispatch = useDispatch()
  const sundriesSelector = useSelector(state => state.sundries)

  const [filters, setFilters] = useState('');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);

  useEffect(() => {
    dispatch(fetchSundryAccounts(filters, page, perPage))

    if(sundriesSelector.createdSundryItem !== null){
      setCreatingSundryItem(false)
    }

    return () => {
      
    };
  }, [dispatch, filters, page, perPage, sundriesSelector.createdSundryItem]);

  const tableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{}
  }

  const columnWidths = {
    reference: 'w-2/12',
    student: 'w-4/12',
    accountStatus: 'w-2/12',
    balance: 'w-2/12',
    '': 'w-2/12'
  }

  const cleanupData = (dataSet) => {
    if(!dataSet) {
      return []
    }
    const data = []

    dataSet.forEach((item, itemIndex) => {
      data.push(
        {
          reference: <p className='font-space-grotesk font-[550]'>{item.reference}</p>,
          student: <ApplicantTableSnippet applicant={item.student} />,
          accountStatus: <StudentStatus status={item.active ? 'ACTIVE' : 'INACTIVE'} />,
          balance: <p className='font-space-grotesk font-[550] text-[15px]'>₦{(item.balance/100).toLocaleString()}</p>,
          '': <Link to={item._id} className='p-[10px] rounded transition duration-200 bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 flex items-center gap-x-[5px] font-space-grotesk font-medium'>Account Details <ArrowIcon className={`w-4 h-4`} /></Link>
        },
      )
    })

    return data
  }

  const searchAccounts =  debounce((term) => {
    console.log('search term -> ', term)
    if(!term || term === ''){
      setFilters('')
      return
    }
    setFilters(`reference=${term}`)
  })

  const [itemsSectionOpen, setItemsSectionOpen] = useState(false);
  const [creatingSundryItem, setCreatingSundryItem] = useState(false);

  return (
    <>
      <div className="w-full">
        <div className='py-3 mb-5'>
          <div className="w-full mx-auto">
            <div className='w-full flex items-center justify-between'>
              <div className='w-2/3'>
                  <h4 className='font-medium text-lg mb-1 text-gray-400'>Sundry Accounts</h4>
                  <div className=''>
                      <p className='text-gray-500 mt-1 text-sm'>
                          Below is a list of students sundry accounts
                      </p>
                  </div>
              </div>
              {/* <button onClick={()=>{setValidatingPayment(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                  Record/Validate a payment
              </button> */}
            </div>

            <div className={`w-full bg-gray-100 p-4 rounded-t-[8px] transition duration-200 border mt-6 ${itemsSectionOpen ? 'rounded-b-0' : 'rounded-b-[8px]'}`}>
              <div className='cursor-pointer w-full flex items-center justify-between'>
                <div>
                  <div className='flex items-center gap-x-3'>
                    <h3 className='font-[500]'>Sundry Items</h3>
                    <button onClick={()=>{setCreatingSundryItem(true)}} className='text-vcm-purple bg-vcm-light-purple bg-opacity-20 p-2 transition text-xs duration-200 hover:text-violet-600 font-medium underline'>Create new sundry item</button>
                  </div>
                  <p onClick={()=>{setItemsSectionOpen(!itemsSectionOpen)}} className='text-sm text-gray-500'>Click here to see a list of sundry expense items created. You can also create new sections in this section.</p>
                </div>
                <div className='w-[50px] flex items-center justify-center'>
                  <button onClick={()=>{setItemsSectionOpen(!itemsSectionOpen)}}>
                    <ChevronIcon className={`w-5 h-5 text-gray-500  transition duration-200 ${itemsSectionOpen ? 'rotate-[270deg]' : 'rotate-180'}`} />
                  </button>
                </div>
              </div>
              {itemsSectionOpen && <SundryItems 
                creatingSundryItem={creatingSundryItem} 
                setCreatingSundryItem={(value)=>{setCreatingSundryItem(value)}} 
              />}
            </div>

            <div className='w-full flex items-center justify-between mt-5 p-2 rounded-md border'>
              <div className='w-full'>
                <SundryAccountFilters applyFilters={(filters)=>{
                  console.log('filters => ', filters)
                  setFilters(filters)
                }} 
                />
              </div>
              
              <div className='w-full flex flex-row-reverse gap-x-2'>
                  <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border w-[300px]`}>
                    <ArrowUpTrayIcon className={`w-5 h-5`} />
                    Export Accounts List
                  </button>
                  <SearchField 
                    placeholderText={`Search by account reference`}
                    showResultsDropDown={false}
                    triggerSearch={(term)=>{searchAccounts(term)}}
                    performingSearch={sundriesSelector.loadingSundryAccounts}
                  />
                  
                  {/* <button onClick={()=>{setView('grid')}} className={`${view === 'grid' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                      <SquaresIcon className={`w-7 h-7`} />
                  </button>

                  <button onClick={()=>{setView('list')}} className={`${view === 'list' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                      <ViewListIcon className={`w-7 h-7`} />
                  </button> */}
              </div>
            </div>
          </div>
        </div>

        <div className=''>
          {sundriesSelector.loadingSundryAccounts 
            ? 
              <div className='w-full'>
                <Loader />
              </div>
            : 
              <DataTable
                tableHeaders={tableHeadersFields(cleanupData(sundriesSelector?.sundryAccounts?.accounts)[0]).headers} 
                tableData={cleanupData(sundriesSelector?.sundryAccounts?.accounts)} 
                columnWidths={columnWidths}
                columnDataStyles={{}}
                allFields={tableHeadersFields(cleanupData(sundriesSelector?.sundryAccounts?.accounts)[0]).fields}
                onSelectItems={()=>{}}
                tableOptions={tableOptions}
                pagination={{
                    perPage, 
                    currentPage: page,
                    totalItems: sundriesSelector.sundryAccounts.total,
                }}
                changePage={setPage}
                updatePerPage={setPerPage}
              />
          }
        </div>
      </div>

      <ModalDialog
        shown={creatingSundryItem} 
        closeFunction={()=>{setCreatingSundryItem(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Create new sundry item`}
        dialogTitle='Create a new sundry item'
        maxWidthClass='max-w-md'
        hideActions={true}
      >
        <NewSundryItem 
          closeFunction={()=>{setCreatingSundryItem(false)}} 
        />
      </ModalDialog>
    </>
  )
}

export default SundryAccounts